import { FC } from 'react';
import { useParams } from 'react-router-dom';
import { useQueryClient } from "react-query";
import { useGetClass } from '../../../services/class/class.service';
import useNavigateWithToast from '../../../utils/useNavigateWithToast/useNavigateWithToast';
import EditClassForm from "./EditClassForm";
import Loading from "../../../components/Loading/Loading";
import { useFetchErrorToast } from "../../../utils/useFetchErrorToasts/useFetchErrorToast";
import Header from "../../Bases/Header";

const EditClass: FC = () => {
  const navigateWithToast = useNavigateWithToast();
  const queryClient = useQueryClient();
  const {
    classId: classIdParam
  } = useParams<{ classId: string }>();
  const classId = +(classIdParam ?? '-1')

  const {
    data: getClassResponse,
    isError: getClassIsError,
    error: getClassError
  } = useGetClass({ classId });
  const classData = getClassResponse?.data;

  useFetchErrorToast([
    {
      label: 'Error fetching class data',
      id: 'classDataFetchError',
      isError: getClassIsError,
      error: getClassError
    }
  ]);

  const navigateToTableWithSuccessToast = () => {
    queryClient.invalidateQueries(['class', classId]);
    navigateWithToast(
        `/tables/classes`,
        {
          label: 'Class has been updated successfully',
          id: 'classUpdateSuccess'
        }
    );
  }

  return (
      <>
        <Header
            breadcrumb={{ label: 'Back to Class Table', to: '/tables/classes' }}
            title={`View Class ${classData?.classNo ?? ''} - ${classData?.longDescription ?? ''}`}
        />
        {!!classData
            ? <EditClassForm
                classData={classData}
                onSuccess={navigateToTableWithSuccessToast}
            />
            : <Loading size={12}/>
        }
      </>
  );
};

export default EditClass;